import { Chip, Icon } from "framework7-react";
import { UNTAGGED } from "../../utils/expense-list";
import { sortTagsByName } from "../../utils/tag-suggestions";
import TagChip from "./tag-chip";

const TagFilter = ({ tags = [], filter = [], onChange, onManage }) => {
  const isActive = (id) => filter.includes(`${id}`);
  const toggle = (id) =>
    onChange(
      isActive(id) ? filter.filter((f) => f !== `${id}`) : [...filter, `${id}`],
    );

  return (
    <div className="tag-filter">
      {sortTagsByName(tags).map((tag) => (
        <TagChip
          key={tag.id}
          name={tag.name}
          color={tag.color}
          selected={isActive(tag.id)}
          onClick={() => toggle(tag.id)}
        />
      ))}
      <TagChip
        className="tag-chip-untagged"
        name="Ohne Tag"
        selected={isActive(UNTAGGED)}
        onClick={() => toggle(UNTAGGED)}
      />
      <Chip
        className="tag-chip tag-filter-manage"
        outline
        text="Tags verwalten"
        onClick={onManage}
      >
        <Icon slot="media" ios="f7:gear_alt" md="material:settings" />
      </Chip>
    </div>
  );
};

export default TagFilter;
